import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { 
  Button, 
  Box, 
  Typography, 
  TextField,
} from '@mui/material';


import { Orders, Logger} from '../../controllers';
import { Confirmation } from '../utils';

export default function Main(props) {

    const [orderId, setOrder] = React.useState('');
    const [orderInfo, setInfo] = React.useState({});
    const [shipping, setShipping] = React.useState('');
    const [shippingConfirm, showShippingConfirm] = React.useState(false);
    const [edited, IsEdited] = React.useState(false);

    const handleFetch = async(e) =>{
        e.preventDefault();
        
        if(isNaN(parseInt(orderId))){
            alert('Invalid Input for order ID. \nEx: 1234567890')
            setOrder('');
            return;
        }
        const response = await Orders.GetById(orderId);

        if(!response.success){
            alert('Error Fetching order results');
            setOrder('');
            return;
        }

        setInfo(response.result);
        setOrder('');
    }

    const handleEdit = (e) =>{
        const {name, value} = e.target;

        setInfo(current => ({
            ...current,
            data_general: {
                ...current.data_general,
                ship_info: {
                    ...current.data_general.ship_info,
                    [name]: value
                }
            }
        }));
        IsEdited(true);
    }

    const handleUpdateGeneral = async(e) => {
        const shippingFields = [
            'address_line_1',
            'address_line_2',
            'city',
            'state',
            'country',
            'postal_code',
            'recipient_company_name',
            'recipient_first_name',
            'recipient_last_name'
        ];
        const shipInfo = orderInfo.data_general?.ship_info || {};
        const normalizedShipInfo = Object.fromEntries(
            shippingFields.map(field => [
                field,
                String(shipInfo[field] ?? '').trim()
            ])
        );
        const dataGeneral = {
            ...orderInfo.data_general,
            ship_info: {
                ...shipInfo,
                ...normalizedShipInfo
            }
        };

        const body = {
            order: orderInfo.id,
            data: JSON.stringify(dataGeneral)
        };

        var response = await Orders.UpdateDataGeneralFree(body);

        if (response == undefined){
            alert('No reponse from server. Try again');
            return;
        }

        if (!response.success){
            alert('Error while updating order info. Try again');
            return;
        }

        alert('Order Updated successfully');
    }

    const handleClip = async(value) => {
        navigator.clipboard.writeText(value);
    }

    const handleUpdate = async() => {
        if(!shipping || shipping.trim() === ""){
            alert('Ivalid data for update. Please, check your input');
            return;
        }

        showShippingConfirm(true);
    }

    const handleUpdateConfirm = async() => {
        const data = {

            ...orderInfo.data_general,
            ship_number : shipping
        }

        const payload = {
            order: orderInfo.id,
            data: data
        };

        const response = await Orders.UpdateDataGeneralFree(payload);

        console.log(response);
        if(!response.success){
            alert('Error updating Shipping info. Please, try again');
            return;
        }

        const log = {
            type: 'Update',
            title: 'Shipping Info',
            information: 'Shipping number added to order information'
        }

        await Logger.Order(orderInfo.id, log);

        showShippingConfirm(false);
        setInfo({});
        setShipping('');
        alert('Update Successfull');
    }

    return(
        <Box
            sx={{
                marginTop: 1,
                display: 'flex',
                flexDirection: 'column',
                padding:1
            }}
        >
            <Confirmation 
                open={shippingConfirm} 
                onClose={() => showShippingConfirm(false)} 
                onConfirm={handleUpdateConfirm} 
                title={'Shipping Number Confirmation'} 
                msg={`The Tracking number is: ${shipping}`}
            />

            <Typography component="h1" variant="h6">
              Scan Order ID
            </Typography>
            <Box 
                component='form'
                onSubmit={handleFetch}
            >
                <TextField
                    size='small'
                    margin="normal"
                    required
                    fullWidth
                    label="Enter Order ID"
                    id="order"
                    name="order"
                    autoFocus
                    value={orderId}
                    onChange={e => setOrder(e.target.value)}
                />
            </Box>
            
            {Object.keys(orderInfo).length > 0 && (
                <Box>
                    <Typography component="h1" variant="h6">
                        Order Info
                    </Typography>
                    <Box
                        sx={{
                            display:'flex',
                            flexDirection: 'row',
                            gap:1
                        }}
                    >
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="ORDER ID"
                            autoFocus
                            value={orderInfo.id}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="CASE ID"
                            autoFocus
                            value={orderInfo.case_serial}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        <TextField
                            size='small'
                            margin="normal"
                            fullWidth
                            label="PART COUNT"
                            autoFocus
                            value={orderInfo.parts}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 2
                        }}
                    >
                        <Typography component="h1" variant="h6">
                            Shipping Info
                        </Typography>
                        
                        <Button color='primary' variant='contained' size='small' onClick={handleUpdateGeneral}> UPDATE</Button>
                    </Box>
                 
                    <Box
                        sx={{
                            gap:1
                        }}
                        
                    >
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:'row',
                                gap:1,
                                alignItems:'center'
                            }}
                        >
                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="ADDRESS #1"
                                name='address_line_1'
                                autoFocus
                                value={orderInfo.data_general.ship_info.address_line_1}
                                onChange={handleEdit}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.address_line_1)}>COPY</Button>

                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="ADDRESS #2"
                                name = 'address_line_2'
                                value={orderInfo.data_general.ship_info.address_line_2}
                                onChange={handleEdit}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.address_line_2)}>COPY</Button>

                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="CITY"
                                name='city'
                                autoFocus
                                value={orderInfo.data_general.ship_info.city}
                                onChange={handleEdit}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.city)}>COPY</Button>
                        </Box>
                        
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:'row',
                                gap:1,
                                alignItems:'center'
                            }}
                        >
                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="STATE"
                                name='state'
                                autoFocus
                                value={orderInfo.data_general.ship_info.state}
                                onChange={handleEdit}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.state)}>COPY</Button>

                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="COUNTRY"
                                name='country'
                                value={orderInfo.data_general.ship_info.country}
                                onChange={handleEdit}

                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.country)}>COPY</Button>
                            
                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="POSTAL CODE"
                                name='postal_code'
                                autoFocus
                                value={orderInfo.data_general.ship_info.postal_code}
                                onChange={handleEdit}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.postal_code)}>COPY</Button>

                        </Box>

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:'row',
                                gap:1,
                                alignItems:'center'
                            }}
                        >
                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="COMPANY NAME"
                                name='recipient_company_name'
                                autoFocus
                                value={orderInfo.data_general.ship_info.recipient_company_name}
                                onChange={handleEdit}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.recipient_company_name)}>COPY</Button>
                       
                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="RECIPIENT FIRST NAME"
                                name='recipient_first_name'
                                autoFocus
                                value={orderInfo.data_general.ship_info.recipient_first_name}
                                onChange={handleEdit}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.recipient_first_name)}>COPY</Button>
                       
                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="RECIPIENT SECOND NAME"
                                name='recipient_last_name'
                                autoFocus
                                value={orderInfo.data_general.ship_info.recipient_last_name}
                                onChange={handleEdit}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={() => handleClip(orderInfo.data_general.ship_info.recipient_last_name)}>COPY</Button>

                        </Box>
                        
                    </Box>

                    <Typography component="h1" variant="h6">
                        Shipping Number Updating
                    </Typography>
                    <Box
                        sx={{
                            gap:1
                        }}
                        
                    >
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:'row',
                                gap:1,
                                alignItems:'center'
                            }}
                        >
                            <TextField
                                size='small'
                                margin="normal"
                                fullWidth
                                label="Traking Number"
                                autoFocus
                                value={shipping}
                                onChange={e => setShipping(e.target.value)}
                            />
                            <Button color='primary' variant='contained' size='small' sx={{height:'4vh'}} onClick={handleUpdate}>UPDATE</Button>
                        </Box>
                    </Box>

                </Box>
            )}
        </Box>
    );
}
